export const Settlement = {
    currency : ['HKD','USD']
}
